import { render, staticRenderFns } from "./Field.vue?vue&type=template&id=ca2967dc&scoped=true"
import script from "./Field.vue?vue&type=script&lang=js"
export * from "./Field.vue?vue&type=script&lang=js"
import style0 from "./Field.vue?vue&type=style&index=0&id=ca2967dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2967dc",
  null
  
)

export default component.exports